// js
import React from 'react';
import PropTypes from 'prop-types';
import RollUpOverviewRowPPTX from './RollUpOverviewRowPPTX';
import RollUpOverviewAuxStatsRowPPTX from './RollUpOverviewAuxStatsRowPPTX';


const RollUpOverviewTotalsPPTX = ({
  configuredItems,
  dataRequired,
  percentIndexed,
  dataIndexed,
  ciscoDataPerDay,
  nonCiscoDataPerDay,
  ciscoDataIndexed,
  nonCiscoDataIndexed,
  ciscoPercentIndexed,
  nonCiscoPercentIndexed,
  showPercentIndexed,
  peakBuffer,
  environmentDataPerDay
}) => {
  return (
    <div className='analytics__roll-up-overview-pptx__totals'>
      <RollUpOverviewRowPPTX
        title='Totals'
        configuredItems={configuredItems}
        dataRequired={dataRequired}
        percentIndexed={percentIndexed}
        dataIndexed={dataIndexed}
        ciscoDataPerDay={ciscoDataPerDay}
        nonCiscoDataPerDay={nonCiscoDataPerDay}
        ciscoDataIndexed={ciscoDataIndexed}
        nonCiscoDataIndexed={nonCiscoDataIndexed}
        ciscoPercentIndexed={ciscoPercentIndexed}
        nonCiscoPercentIndexed={nonCiscoPercentIndexed}
        showPercentIndexed={showPercentIndexed}
      />
      <RollUpOverviewAuxStatsRowPPTX
        title='Totals'
        peakBuffer={peakBuffer}
        environmentDataPerDay={environmentDataPerDay}
        showPercentIndexed={showPercentIndexed}
      />
    </div>
  );
};

RollUpOverviewTotalsPPTX.defaultProps = {
  ciscoDataPerDay: 0,
  nonCiscoDataPerDay: 0,
  ciscoDataIndexed: 0,
  nonCiscoDataIndexed: 0,
  ciscoPercentIndexed: 0,
  nonCiscoPercentIndexed: 0
};

RollUpOverviewTotalsPPTX.propTypes = {
  configuredItems: PropTypes.number.isRequired,
  dataRequired: PropTypes.number.isRequired,
  percentIndexed: PropTypes.number.isRequired,
  dataIndexed: PropTypes.number.isRequired,
  ciscoDataPerDay: PropTypes.number,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number,
  ciscoPercentIndexed: PropTypes.number,
  nonCiscoPercentIndexed: PropTypes.number,
  showPercentIndexed: PropTypes.bool.isRequired,
  peakBuffer: PropTypes.number.isRequired,
  environmentDataPerDay: PropTypes.number.isRequired
};

export default RollUpOverviewTotalsPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewTotalsPPTX.js